var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loadingspinner",class:[
    {
      'loadingspinner-small': _vm.props.size === 'small',
      'loadingspinner-dark': _vm.props.color === 'dark'
    },
    _vm.data.staticClass
  ]},[_vm._m(0)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"lds-spinner"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])}]

export { render, staticRenderFns }